import React from 'react'
import Text from 'src/components/ts-components/Text'
import colors from '@sportninja/common/constants/appColors'

interface ModalHeaderProps {
  teamName?: string
}

/** Header component for the ManageTeamAttendance modal */
const ModalHeader: React.FC<ModalHeaderProps> = ({ teamName }) => {
  return (
    <Text
      variant='heading3'
      weight='semiBold'
      color={colors.WHITE}
      textTransform='capitalize'
    >
      {`Attendance - ${teamName}`}
    </Text>
  )
}

export default React.memo(ModalHeader)
